import type { PropsWithChildren } from 'react';

export type ShowSkeletonProps = PropsWithChildren<{}>;

/**
 * Wrapper to activate .skeleton & .skeleton-hidden
 * it use scss written in src/styles/skeleton.scss
 */
export function ShowSkeleton({ children }: ShowSkeletonProps) {
  return (
    <div className="skeleton-wrapper" aria-hidden>
      {children}
    </div>
  );
}
